import type { IChargerByDeviceStatusKpi } from '@/models/KPIs/IChargerByDeviceStatusKpi'
import type { IEntityByConnectorChargingStatusKpi } from '@/models/KPIs/IEntityByConnectorChargingStatusKpi'
import { inject, injectable } from 'inversify'
import type IApiClient from '../IApiClient'
import { SERVICES_TYPES } from '../ServicesTypes'
import type IKpiService from './IKpiService'
import type { ILocalControllersByConnectionStatusKpi } from '@/models/KPIs/ILocalControllersByConnectionStatusKpi'
import type { ISimStatusKpi } from '@/models/KPIs/ISimStatusKpi'
import type { IConnectivityStatusKpi } from '@/models/KPIs/IConnectivityStatusKpi'

@injectable()
export class KpiService implements IKpiService {
  private readonly apiClient: IApiClient
  private readonly kpiBaseUri: string = 'kpi'

  constructor(@inject(SERVICES_TYPES.ApiClient) apiClient: IApiClient) {
    this.apiClient = apiClient
  }

  public async getLocalControllerConnectionKPI(): Promise<ILocalControllersByConnectionStatusKpi> {
    return this.apiClient.get<ILocalControllersByConnectionStatusKpi>(`${this.kpiBaseUri}/local-controllers/connection-statuses`)
  }

  public async getChargingSiteCountByConnectorChargingStatus(): Promise<IEntityByConnectorChargingStatusKpi> {
    return this.apiClient.get<IEntityByConnectorChargingStatusKpi>(`${this.kpiBaseUri}/charging-sites/connector-charging-statuses`)
  }

  public async getChargerCountByConnectorChargingStatus(): Promise<IEntityByConnectorChargingStatusKpi> {
    return this.apiClient.get<IEntityByConnectorChargingStatusKpi>(`${this.kpiBaseUri}/chargers/connector-charging-statuses`)
  }

  public async getChargerConnectivityStatusKPI(): Promise<IConnectivityStatusKpi> {
    return this.apiClient.get<IConnectivityStatusKpi>(`${this.kpiBaseUri}/chargers/online-offline-statuses`)
  }

  public async getChargerSimStatusKPI(): Promise<ISimStatusKpi> {
    return this.apiClient.get<ISimStatusKpi>(`${this.kpiBaseUri}/chargers/sim-online-offline-statuses`)
  }

  public async getChargerDeviceStatusKPI(): Promise<IChargerByDeviceStatusKpi> {
    return this.apiClient.get<IChargerByDeviceStatusKpi>(`${this.kpiBaseUri}/chargers/device-statuses`)
  }
}
